"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var bar_chart_1 = require("./bar-chart");
var geometry_1 = require("../geometry");
/**
 * Data format: {min, max}[]
 */
var RangeChart = /** @class */ (function (_super) {
    __extends(RangeChart, _super);
    function RangeChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RangeChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_minValueFunc":
            case "_maxValueFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    RangeChart.prototype.defaultOptions = function () {
        return __assign({ _minValueFunc: function (d) { return d.min; }, _maxValueFunc: function (d) { return d.max; } }, _super.prototype.defaultOptions.call(this));
    };
    RangeChart.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._rects = this._groups.appendT(element_1.Rect).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
        });
        this._labelsMin = this._groups.appendT(element_1.Text).options({
            _anchor: 8 /* Bottom */ | 32 /* Center */,
            _relatedTo: 2 /* Top */ | 32 /* Center */,
            _x: 0,
            _y: 0,
            _text: function (d, i) { return _this._minFunc(d, i).toString(); },
        });
        this._labelsMax = this._groups.appendT(element_1.Text).options({
            _anchor: 2 /* Top */ | 32 /* Center */,
            _relatedTo: 8 /* Bottom */ | 32 /* Center */,
            _x: 0,
            _y: 0,
            _text: function (d, i) { return _this._maxFunc(d, i).toString(); },
        });
    };
    RangeChart.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this._minFunc = this.getOption("_minValueFunc");
        this._maxFunc = this.getOption("_maxValueFunc");
        this.setupProxy({
            bar: "_rects",
            labelMin: "_labelsMin",
            labelMax: "_labelsMax",
        });
    };
    RangeChart.prototype._getMax = function () {
        var maxVal = this.getOption("_maxValue");
        return maxVal > 0 ? maxVal : d3.max(this.datum, this.getOption("_maxValueFunc"));
    };
    RangeChart.prototype._getMin = function () {
        var minVal = this.getOption("_minValue");
        return minVal > 0 ? minVal : d3.min(this.datum, this.getOption("_minValueFunc"));
    };
    RangeChart.prototype._getXOrY = function (horizontal) {
        var _this = this;
        return function (d, i) {
            if (horizontal === _this._isHorizontal) {
                return _this.scale(_this._minFunc(d, i));
            }
            else {
                return _this._gap * 0.5 + _this._thick * 0.5 + i * (_this._thick + _this._gap);
            }
        };
    };
    RangeChart.prototype._getWidthOrHeight = function (horizontal) {
        var _this = this;
        return function (d, i) {
            if (horizontal === _this._isHorizontal) {
                return Math.abs(_this.scale(_this._maxFunc(d, i)) - _this.scale(_this._minFunc(d, i)));
            }
            else {
                return _this._thick;
            }
        };
    };
    RangeChart.prototype.postOptionsUpdate = function () {
        _super.prototype.postOptionsUpdate.call(this);
        var gravity = this.getOption("_gravity");
        var isHorizontal = gravity === __1.Gravity.Left || gravity === __1.Gravity.Right;
        var isInversed = gravity === __1.Gravity.Bottom || gravity === __1.Gravity.Right;
        var getAnchor = function (isInversed, isMax) {
            return (isHorizontal ? 4 /* Middle */ : (isInversed === isMax ? 8 /* Bottom */ : 2 /* Top */)) |
                (isHorizontal ? (isInversed === isMax ? 64 /* Right */ : 16 /* Left */) : 32 /* Center */);
        };
        this._labelsMax.options({
            _anchor: getAnchor(isInversed, true),
            _relatedTo: getAnchor(!isInversed, true),
        });
        this._labelsMin.options({
            _anchor: getAnchor(isInversed, false),
            _relatedTo: getAnchor(!isInversed, false),
        });
    };
    return RangeChart;
}(bar_chart_1.BaseBarChart));
exports.RangeChart = RangeChart;
//# sourceMappingURL=range-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/range-chart.js
// module id = 244
// module chunks = 0 1